import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { Components_Searchbar_25F45B5E } from "../Components/Searchbar.js";
import { debounce as debounce_1 } from "../Utils.js";

/**
 * Component for the search filter input. Adds a timer to the input to avoid triggering model update on every key stroke
 */
export function Tickets_Searchbar_BBCD08A(tickets_Searchbar_BBCD08AInputProps) {
    const onUpdate = tickets_Searchbar_BBCD08AInputProps.onUpdate;
    const placeholder = tickets_Searchbar_BBCD08AInputProps.placeholder;
    const patternInput = reactApi.useState(placeholder);
    const timer = reactApi.useRef(0);
    return createElement(Components_Searchbar_25F45B5E, {
        placeholder: patternInput[0],
        onChange: (ev) => {
            console.debug("Ticket searchbar ev", ev);
            const str = ev.target.value;
            debounce_1(500, timer, () => {
                onUpdate(str.trim());
            });
            patternInput[1](str);
        },
        fullWidth: true,
    });
}

